import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import R8HeaderTable, { R8HeaderTableGeneric } from './r8-header-table-generic'

const columns: ColumnProps<R8HeaderTableGeneric>[] = [
  {
    align: 'center',
    dataIndex: 'name',
    key: 'name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.header.agencies.agency'
  },
  {
    align: 'center',
    dataIndex: 'total',
    key: 'total',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.8.header.agencies.total'
  },
  {
    align: 'center',
    dataIndex: 'percent',
    key: 'percent',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.header.agencies.percent'
  }
]

function R8HeaderTableAgencies({
  dataSource
}: TableProps<R8HeaderTableGeneric>) {
  return <R8HeaderTable columns={columns} dataSource={dataSource} />
}

export default R8HeaderTableAgencies
